class ExternalLinkManager {
    constructor() {
        this.LINKS_CONFIG = {
            'med-class-info': '/pages/zertifizierte-medizinprodukte',
            'kt-basic-udi-info': 'https://cdn.shopify.com/s/files/1/0749/4923/0883/files/EC_Declaration_of_Conformity_K-Tape_2024.pdf?v=1746224022',
            'cross-basic-udi-info': 'https://cdn.shopify.com/s/files/1/0749/4923/0883/files/EC_Declaration_of_Conformity_Crosstape_2024.pdf?v=1746224021'
        };

        this.initExternalLinks();
    }

    initExternalLinks() {
        Object.entries(this.LINKS_CONFIG).forEach(([elementId, url]) => {
            $(`#${elementId}`).on('click', (e) => this.openInNewTab(url, e));
        });
    }

    openInNewTab(url, event) {
        event.preventDefault();
        window.open(url, '_blank');
    }
}